// Shared defaults for every tenant. 
// A tenant config file only needs to specify what is actually different for that company
// Everything else is inherited via deepMerge

const base = {
    locale: {
        currency:       'LKR',
        currencyLocale: 'en-LK',
        dateLocale:     'en-GB',
        dateFormat:     { day: '2-digit', month: 'short', year: 'numeric' },
        dateTimeFormat: { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' },
        timezone:       'Asia/Colombo',
        defaultMapCenter: { lat: 6.927079, lng: 79.861244 },
        defaultMapZoom:   13,
    },

    formatting: {
        currencyMinFractionDigits: 0,
        currencyMaxFractionDigits: 2,
        hoursDecimalPlaces:        1,
        coordinateDecimalPlaces:   6,
        largeNumberDivisor:        1000000,
        largeNumberSuffix:         'M',
        smallNumberDivisor:        1000,
        smallNumberSuffix:         'K',
    },

    api: {
        authHeader: 'auth-key',
         baseUrl: process.env.REACT_APP_API_BASE_URL      || 'https://erpbackend.dockyardsoftware.com',
        //baseUrl: process.env.REACT_APP_API_BASE_URL      || 'https://dgeserp.dockyardsoftware.com',
       // baseUrl: process.env.REACT_APP_API_BASE_URL      || 'https://ceyloncoco.dockyardsoftware.com',
       // baseUrl: process.env.REACT_APP_API_BASE_URL      || 'http://localhost:51324',
    },

    auth: {
        loginFieldLabel:       'Service Number',
        loginFieldPlaceholder: 'Enter your service number',
        passwordPlaceholder:   'Enter your password',
        storageKeys: {
        token: 'erp_token',
        logId: 'erp_log_id',
        user:  'erp_user',
        },
    },

    rules: {
        lateThresholdMinutes:  540,
        maxUploadSizeMB:       5,
        searchResultsLimit:    8,
        attendanceConcurrency: 6,
    },

    validation: {
        nationalIdRegex: /^[0-9]{9}[VXvx]$|^[0-9]{12}$/,
        nationalIdLabel: 'NIC',
        phoneExample:    '0771234567',
        landlineExample: '0112345678',
        emailExample:    'name@company.lk',
    },

    modules: {
        enabled: [
            'dashboard', 'asset', 'commercial', 'finance', 'hrm',
            'office', 'procurement', 'production', 'subcontract', 'masterfiles',
        ],
        names: {
            dashboard:   'Dashboard',
            asset:       'eAsset',
            commercial:  'eCommercial',
            finance:     'eFinancials',
            hrm:         'eHRM',
            office:      'eOffice',
            procurement: 'eProcurement',
            production:  'eProduction',
            subcontract: 'eSubcontract',
            masterfiles: 'Master Files',
        },
        descriptions: {
            asset:       'Asset & Transfer Management',
            commercial:  'Sales & Project Proposals',
            finance:     'Accounts & Financial Reports',
            hrm:         'HR & Attendance Management',
            office:      'Work & Job Management',
            procurement: 'Suppliers & Stock Control',
            production:  'EWO & Material Management',
            subcontract: 'Contractor Management',
        },
    },
    
    seedData: {
        religions:   ['Buddhism', 'Hinduism', 'Islam', 'Christianity', 'Other'],
        races:       ['Sinhalese', 'Tamil', 'Muslim', 'Burgher', 'Malay', 'Other'],
        provinces:   ['Western', 'Central', 'Southern', 'Northern', 'Eastern',
                    'North Western', 'North Central', 'Uva', 'Sabaragamuwa'],
        bloodGroups: ['A+', 'A-', 'B+', 'B-', 'AB+', 'AB-', 'O+', 'O-'],
    },

    featureFlags: {
        enableMenuPermissions: false,
        disabledMenuCodes: [
            'ERP1038', 'ERP1039', 'ERP1040', 'ERP1041', 'ERP1042', 'ERP1043', 'ERP1044',
        ],
        enableMonthlyAllocation: true,
    },

    theme: {
        // Company theme only need to define 'primary' and 'chartColors'
        surface: {
            50:  '#f9f9f9', 100: '#ececec', 200: '#d4d4d4', 300: '#a0a0a0',
            400: '#6b6b6b', 500: '#3d3d3d', 600: '#2a2a2a', 700: '#1f1f1f',
            800: '#141414', 900: '#0a0a0a',
        },
        accent: {
            solid: null,
            dark: null,
            tint: null,
            ring: null,
        },
    }
}

export default base;